module.exports = __webpack_public_path__ + "static/media/img162.f0512815.jpg";